import React from 'react';

import { callApi } from 'helpers/callApi/callApi';
import AppModal from 'components/modal/appModal';
import { CancelEventModalContentProps } from './CancelEventModal.types';

export const CancelEventModalContent = ({ id, cancelEvent, data: { event }, close }: CancelEventModalContentProps) => {
  const handleSubmit = () => {
    callApi({
      action: () => cancelEvent(event.id),
      onSuccess: close,
    });
  };

  return (
    <AppModal
      id={id}
      title="Cancel event"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <p>
        Are you sure you want to cancel <strong>{event.name || 'unnamed'}</strong> event?
      </p>
    </AppModal>
  );
};
